'use client'

import {
  classifyMetricError,
  isMetricOutcome,
  type MetricOptions,
  metricNow,
} from './metrics'
import {
  type ClientJourneyOutcome,
  startClientJourney,
} from './metrics-browser'

/** Synchronous callback elapsed time; use bounded window aggregation on per-frame/chunk hot paths. */
export function measureClientOperation<T>(
  operation: string,
  options: MetricOptions & {
    classifyResult?: (result: T) => ClientJourneyOutcome
  },
  callback: () => T
): T {
  const journey = startClientJourney(operation, options)
  try {
    const result = callback()
    const completedAt = metricNow()
    let outcome: ClientJourneyOutcome = 'success'
    try {
      if (options.classifyResult) {
        const classified = options.classifyResult(result)
        outcome = isMetricOutcome(classified) ? classified : 'unknown'
      }
    } catch {
      outcome = 'unknown'
    }
    journey.finish(outcome, { completedAt })
    return result
  } catch (error) {
    const completedAt = metricNow()
    journey.finish(classifyMetricError(error), { completedAt })
    throw error
  }
}
